var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditGroupChatName(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.42,
    height: 17.215,
    viewBox: "0 0 22.42 17.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit_Name",
    "data-name": "Edit Name",
    transform: "translate(-133 -347.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160709",
    "data-name": "Group 160709",
    transform: "translate(-89 0.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83194",
    "data-name": "Path 83194",
    d: "M12.44,3.81l1.176-1.177a1.308,1.308,0,0,1,1.849,1.849L5.445,14.5a3.138,3.138,0,0,1-1.323.788l-1.872.558.558-1.872A3.138,3.138,0,0,1,3.6,12.653L12.441,3.81Zm0,0,1.84,1.84",
    transform: "translate(227.821 345.911)",
    fill: "rgba(0,0,0,0)",
    stroke: "#6d7077",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_140152",
    "data-name": "Rectangle 140152",
    transform: "translate(222 362.766)",
    fill: "none",
    stroke: "#6d7077",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.612,
    height: 1.735,
    rx: 0.867,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 12.112,
    height: 0.235,
    rx: 0.117,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGroupChatName);
export default __webpack_public_path__ + "static/media/Edit-group-chat-name.2f93d324e06c6b49bd03b3ddb950230a.svg";
export { ForwardRef as ReactComponent };